import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'material-ui/Button'
import { CircularProgress } from 'material-ui/Progress'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import FormPasswordToggleField from '../components/formPasswordToggleField'
import FormTextField from '../components/formTextField'
import FormSelector from '../components/formSelector'
import green from 'material-ui/colors/green'
import Messages from '../constants/messages'
import { PasswordRequirements } from '../components/passwordRequirements'
import { preserveReduxFormValueOnToggle } from '../modules/securityQuestionsFormDialog'
import { fetchRegistrationUser, patchUser } from '../modules/registration'
import { fetchStockSecurityQuestions } from '../modules/securityQuestionsFormDialog'
import { setAppContext } from '../modules/appContext'
import { setSecurityQuestion } from '../modules/authProfile'
import Tooltip from 'material-ui/Tooltip'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import { match, minCharacters, notContainEmail, notContainPassword, notBeQuestionPart, required, strength, notContainFirstName, notContainLastName } from '../utils/validationRules'
import { LoadingIndicator } from '../components/loadingIndicator';

const PROP_TYPES = {
  completedMessage: PropTypes.string,
  expirationMessage: PropTypes.string,
  resetPassword: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  userId: PropTypes.string
}

const styles = theme => ({
  root: {
    minWidth: 320,
    maxWidth: 600,
    width: '30%',
    margin: 'auto'
  },
  button: {
    minWidth: 150,
    maxWidth: 300,
    width: '60%',
    marginTop: 25
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '73%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  copyright: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'left'
  },
  confirmCheck: {
    color: green[500],
      '&:after': {
        content: "' \u2714'"
      }
  },
  confirmNoCheck: {
    color: green[500]
  },
  divider: {
    marginBottom: 25
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    padding: 10,
    fontSize: 12
  },
  form: {
    padding: '0 20%',
    textAlign: 'center'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'black'
  },
  nordstromLogo: {
    width: '70%',
    paddingBottom: 30
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  passwordToolTip: {
    paddingLeft: 20,
    textAlign: 'left',
    fontSize: '1.5em',
    '& ul': {
      paddingLeft: 20
    }
  },
  wrapper: {
    position: 'relative'
  }
})

const maxLength = value => {
  return (value && value.length > 50 ? Messages['fieldErrors']['MAX_LENGTH'] : undefined)
}

export class Registration extends Component {

  componentDidMount() {
    const { fetchRegistrationUser, fetchStockSecurityQuestions, initialValues, match, securityQuestionsList } = this.props
    if (!match.path.includes('-expired')) {
      let userId = match.params.userId ? atob(match.params.userId) : ''
      if (!initialValues.email) {
        fetchRegistrationUser(userId)
        .then(() => {
          if(!(securityQuestionsList && securityQuestionsList.length)) {
            fetchStockSecurityQuestions()
          }
        })
        .catch(() => window.location = '/unauthorized')
      }      
    }
  }

  renderCompleted() {
    // TODO: remove this hardcoding in https://jira.nordstrom.net/browse/NID-1562
    const { classes, completedMessage, initialValues } = this.props
    let markup
    if(initialValues.appName === 'Vendor Portal - Supplier Reports') {
      markup = (
        <div className={classes.contents} id="completedMessage">
          {completedMessage}<br/><br/>
          {Messages['pageMessages']['SUPPLIER_REPORTS_URL_MSG']}<br/><br/>
          <a href="https://partner.nordstrom.com">https://partner.nordstrom.com</a>
        </div>
      )
    } else {
      markup = (
        <div className={classes.contents} id="completedMessage">
          {completedMessage}
        </div>
      )
    }
    return markup
  }

  renderExpired() {
    const { classes, expirationMessage } = this.props
    return (
      <div className={classes.contents} id="expiredMessage">
        {expirationMessage}
      </div>
    )
  }

  renderForm(){
    const {
      isRegistering,
      isSubmitting,
      classes,
      resetPassword,
      handleSubmit,
      patchUser,
      securityQuestionsList,
      setSecurityQuestion,
      submitting,
      userId } = this.props

      return (
        <form
          className={classes.form}
          onSubmit={handleSubmit((values) => {
            const { answer, password, matchingPassword, firstName, lastName, question } = values
            const registrationBody = {
              password,
              matchingPassword,
              firstName,
              lastName
            }
            if (!!answer && !!question) {
              setSecurityQuestion(userId, {answer, question})
            }
            patchUser(userId, registrationBody)
          })}>
            <Field
              name="appName"
              label={Messages['uiComponents']['APPLICATION_NAME_FIELD']}
              component={FormTextField}
              type="text"
              disabled={true} />
            <Field
              name="partner"
              label={Messages['uiComponents']['PARTNER_NAME_INPUT_FIELD']}
              component={FormTextField}
              type="text"
              disabled={true} />
            <Field
              name="email"
              label={Messages['uiComponents']['EMAIL_INPUT_FIELD']}
              component={FormTextField}
              type="text"
              disabled={true} />

          { !resetPassword && [
              <Field
                key="firstNameField"
                name="firstName"
                label={Messages['uiComponents']['REGISTRATION_FIRST_NAME_INPUT_FIELD']}
                component={FormTextField}
                type="text"
                disabled={true}
                validate={[maxLength, required]} />,
              <Field
                key="lastNameField"
                name="lastName"
                label={Messages['uiComponents']['REGISTRATION_LAST_NAME_INPUT_FIELD']}
                component={FormTextField}
                type="text"
                disabled={true}
                validate={[maxLength, required]} />,
              <Field
                key="questionField"
                name="question"
                component={FormSelector}
                label={Messages['uiComponents']['SECURITY_QUESTION_LABEL']}
                disabled={isSubmitting}
                optionsList={securityQuestionsList}
                type="text"
                validate={[required]} />,
              <Field
                key="answerField"
                name="answer"
                component={FormPasswordToggleField}
                label={Messages['uiComponents']['ANSWER_LABEL']}
                disabled={isSubmitting}
                preserveReduxFormValueOnToggle={preserveReduxFormValueOnToggle}
                type="password"
                validate={[required, minCharacters, notContainEmail, notContainPassword, notBeQuestionPart]} />
            ]
          }
          <Tooltip id="tooltip-top" title={this.renderPasswordToolTip()} placement="top">
            <Field
              name="password"
              type="password"
              label={Messages['uiComponents']['REGISTRATION_PASSWORD_INPUT_FIELD']}
              component={FormTextField}
              validate={[required, strength, notContainEmail, notContainFirstName, notContainLastName]} />
          </Tooltip>
          <Field
            name="matchingPassword"
            type="password"
            label={Messages['uiComponents']['REGISTRATION_CONFIRM_PASSWORD_INPUT_FIELD']}
            component={FormTextField}
            validate={[required, match]} />
          {resetPassword ? null : this.renderTermsConditions()}
          <div className={classes.wrapper}>
            <Button
              className={classes.button}
              type="submit"
              raised
              color="primary"
              disabled={submitting}>
              {resetPassword ?
                Messages['uiComponents']['CHANGE_BUTTON'] : Messages['uiComponents']['REGISTRATION_SUBMIT_BUTTON']}
            </Button>
            {isRegistering && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        </form>
      )
  }

  renderTermsConditions() {
    const { classes, initialValues } = this.props
    let markup = null
    if ( initialValues && initialValues.appName === 'Vendor Portal - Supplier Reports') {
      markup = (
        <Typography type="body1" align='center' data-test-id="terms-conditions">
          {Messages['pageMessages']['VENDORS_TERMS_MSG1']}
          <a href="https://partner.nordstrom.com/#/terms" className={classes.link} target="_blank" rel="noopener noreferrer">{Messages['pageMessages']['VENDORS_TERMS_LINK']}</a>
          {Messages['pageMessages']['VENDORS_TERMS_MSG2']}
        </Typography>
      )
    }
    return markup
  }

  renderPasswordToolTip() {
    const { classes, password, initialValues } = this.props
    let email = initialValues && initialValues.email ? initialValues.email : ''
    let firstName = initialValues && initialValues.firstName ? initialValues.firstName : ''
    let lastName = initialValues && initialValues.lastName ? initialValues.lastName : ''
    return <PasswordRequirements classes={classes} email={email} firstName={firstName} lastName={lastName} password={password} />
  }

  render() {
    const { classes, completedMessage, expirationMessage, hasReceivedUserInfo } = this.props
    if(completedMessage) {
      return this.renderCompleted()
    } else if(expirationMessage) {
      return this.renderExpired()
    } else {
      return hasReceivedUserInfo ? this.renderForm() : <LoadingIndicator classes={classes} infoText={Messages['uiComponents']['LOADING_MSG']} />
    }
  }
}

Registration.propTypes = PROP_TYPES

const selector = formValueSelector('registration')

const mapStateToProps = state => ({
  isRegistering: state.registration.isRegistering,
  completedMessage: state.registration.completedMessage,
  expirationMessage: state.registration.expirationMessage,
  hasReceivedUserInfo: state.registration.hasReceivedUserInfo,
  resetPassword: state.registration.resetPassword,
  isLoading: state.loading.isLoading,
  isSubmitting: state.securityQuestionsFormDialog.isSubmitting,
  password: selector(state, 'password'),
  userId: state.registration.userId,
  initialValues: state.registration.initialValues,
  securityQuestionsList: state.securityQuestionsFormDialog.stockQuestions
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchRegistrationUser,
  fetchStockSecurityQuestions,
  patchUser,
  preserveReduxFormValueOnToggle,
  setAppContext,
  setSecurityQuestion,
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'registration',
    enableReinitialize: true
  })
)(Registration)
